<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="hxPurchaseDetailCode"
      cell-class-name="align-top"
      auto-resize
      resizable
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="800"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:displayImageUrl="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:100%;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:100%;" />
          </div>
        </el-image>
      </template>

      <template v-slot:displaySkuName="{ row }">
        <TableLabel :value="row.goodsName" />
        <TableLabel :value="row.goodsNameEn" />
        <TableLabel label="SIZE" :value="row.goodsSize" />
        <TableLabel
          label="COLOR"
          :value="`${row.goodsColor || ''}${row.goodsColorEn || ''}`"
        />
        <TableLabel label="BRAND" :value="row.brandName" />
        <TableLabel
          label="CATEGORY"
          :value="
            `${row.masterCategoryName || ''}${row.detailCategoryName || ''}`
          "
        />
      </template>
      <template v-slot:displaySkuNo="{ row }">
        <TableLabel label="NC" :value="row.ncNo" primary />
        <TableLabel label="SKU" :value="row.hxSkuNo" primary />
        <el-tag
          v-if="row.v_hxSkuSalesChannel"
          size="mini"
          :type="row.hxSkuSalesChannel == 'V' ? 'warning' : ''"
        >
          {{ row.v_hxSkuSalesChannel }}
        </el-tag>
      </template>
      <template v-slot:displayPurchase="{ row }">
        <TableLabel label="订单号" :value="row.hxPurchaseNo" primary />
        <TableLabel label="执行工厂" :value="row.scmName" />
        <TableLabel label="名义工厂" :value="row.orderScmName" />
        <TableLabel label="结算工厂" :value="row.settlementFactoryName" />
      </template>
      <template v-slot:displayBox="{ row }">
        <TableLabel
          label="CTN"
          :value="`${row.ctnLength}x${row.ctnWidth}x${row.ctnHeight}cm`"
        />
        <TableLabel label="N.W" :value="`${row.ctnNetWeight || 0} kg`" />
        <TableLabel label="G.W" :value="`${row.ctnGrossWeight || 0} kg`" />
        <TableLabel label="CBM" :value="`${row.ctnCbm || 0} m³`" />
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableLabel from './label.vue'
export default {
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    cellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'displayImageUrl']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)
      
      const data = $table
        .getCheckboxRecords()
        .concat($table.getCheckboxReserveRecords())
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
